import { motion } from "@smartsheet/design-tokens";
import { themed } from "../../../util/theme";
import { BaseButtonStyledProps } from "../types";

const motionTheme = themed({
    "lodestar-light": "",
    "ursa-light": `all ${motion.animation.default}`,
});

export const getButtonMotion = ({ themeMode }: BaseButtonStyledProps) => {
    return motionTheme(themeMode);
};
